const MAPA_PECA: Record<string, string> = { K: 'R', Q: 'D', R: 'T', B: 'B', N: 'C' };

export function sanParaPortugues(san: string): string {
  if (!san) return san;
  let resultado = san.replace(/^([KQRBN])/, (_, peca: string) => MAPA_PECA[peca] ?? peca);
  resultado = resultado.replace(/=([QRBN])/g, (_, peca: string) => `=${MAPA_PECA[peca] ?? peca}`);
  return resultado;
}

export function nomeDaCor(cor: 'w' | 'b'): string {
  return cor === 'w' ? 'Brancas' : 'Pretas';
}

export function nomeDaPeca(tipo: string): string {
  return ({ p: 'peão', n: 'cavalo', b: 'bispo', r: 'torre', q: 'dama', k: 'rei' } as Record<string, string>)[tipo] ?? 'peça';
}

export function formatarTempo(ms: number, mostrarDecimos = true): string {
  const seguro = Math.max(0, ms);
  if (mostrarDecimos && seguro < 10_000) {
    const segundos = Math.floor(seguro / 1000);
    const decimos = Math.floor((seguro % 1000) / 100);
    return `0:${segundos.toString().padStart(2, '0')}.${decimos}`;
  }
  const totalSegundos = Math.ceil(seguro / 1000);
  const minutos = Math.floor(totalSegundos / 60);
  const segundos = totalSegundos % 60;
  return `${minutos}:${segundos.toString().padStart(2, '0')}`;
}
